import React from 'react';
import { Row, Col } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
//custom-hook
import useAssignedLibrary from 'utils/customHooks/useAssignedLibrary';
// Imagen
import preview from 'assets/img/preview.jpg';
//preview
import CoverImg from '../coverImage/CoverImage';
// Componentes
import Button from 'components/userzone/buttons/ButtonCustom';

const ItemListRecommendedBook = ({ book }) => {
  const { t } = useTranslation(['home', 'detalle']);
  const { libraryPath } = useAssignedLibrary();
  const navigate = useNavigate();

  const goToDetail = (productId) => {
    navigate(libraryPath(`libro/${productId}`));
  };

  return (
    <div className="store-item award-container">
      <div className="store-item award-container">
        <div className="store-cover">
          <div className="img-container default-cursor">
            <div className="overlay"></div>
            <Link to={libraryPath(`libro/${book.id}`)}>
              <CoverImg src={book.image || preview} className="default-cursor" />
            </Link>
            <div className="label-text-container recommended">
              <p className="label-text">
                {book?.bookstore_recommender?.name
                  ? t('bookstoreRecommender', { ns: 'detalle', name: book.bookstore_recommender.name }).toUpperCase()
                  : t('libreriaRecomienda', { ns: 'detalle' }).toUpperCase()}
              </p>
            </div>
          </div>
        </div>
        <Row className="img-caption img-caption-no-margin">
          <Col xs={12}>
            <Link className="link-awards" to={libraryPath(`libro/${book.id}`)}>
              <h5 className="title-awards limit-long" title={book.title}>
                {book.title?.charAt(0).toUpperCase() + book.title?.slice(1).toLowerCase()}
              </h5>
            </Link>
          </Col>
        </Row>
        <div className="text-center">
          <Button variant="outline-dark" size="sm" className="btn-awards" onClick={() => goToDetail(book.id)}>
            {t('seeFile')}
          </Button>
        </div>
      </div>
    </div>
  );
};

export default ItemListRecommendedBook;
